import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import EmailLink from './EmailLink';

const FaqContent: React.FC = () => {
  const { t, language } = useLanguage();
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());

  // Get all FAQ questions from translations
  const faqQuestions = [
    'what',
    'pricing',
    'summitSelection',
    'summitDetection',
    'scoring',
    'import',
    'privacy'
  ];

  const faqs = faqQuestions.map(key => ({
    question: t(`faq.questions.${key}.question`),
    answer: t(`faq.questions.${key}.answer`),
  }));

  const toggleItem = (index: number) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(index)) {
      newExpanded.delete(index);
    } else {
      newExpanded.add(index);
    }
    setExpandedItems(newExpanded);
  };

  const renderAnswer = (answer: string) => {
    const parts = answer.split(/(<(?:link|privacy)>.*?<\/(?:link|privacy)>)/);
    return parts.map((part, index) => {
      if (part.startsWith('<link>')) {
        const text = part.replace(/<\/?link>/g, '');
        return (
          <Link 
            key={index}
            to={`/${language}/submit-summit`}
            className="inline-link"
          >
            {text}
          </Link>
        );
      }
      if (part.startsWith('<privacy>')) {
        const text = part.replace(/<\/?privacy>/g, '');
        return (
          <Link 
            key={index}
            to={`/${language}/privacy`}
            className="inline-link"
          >
            {text}
          </Link>
        );
      }
      return part;
    });
  };

  return (
    <main className="faq-main">
      <div className="faq-header">
        <h1>{t('faq.title')}</h1>
      </div>
      
      <div className="faq-grid">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`faq-card ${expandedItems.has(index) ? 'expanded' : ''}`}
            onClick={() => toggleItem(index)}
          >
            <div className="faq-card-header">
              <h3 className="faq-question">{faq.question}</h3>
              <div className="faq-toggle">
                <svg 
                  className={`faq-icon ${expandedItems.has(index) ? 'expanded' : ''}`}
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
            
            <div className={`faq-answer ${expandedItems.has(index) ? 'expanded' : ''}`}>
              <div className="faq-answer-content">
                {renderAnswer(faq.answer as string)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
};

export default FaqContent; 